import React from 'react';
import { useTranslation } from 'react-i18next';
import { Values } from '@lib/interfaces/form';
import { GraphQLFormattedError } from 'graphql';
import Form from '@lib/components/ReactHookForm/FormContainer';
import replaceNullsWithUndefined from '@lib/utils/replaceNullsWithUndefined';
import getCategoryFormFields from './utils/getCategoryFormFields';
import CategoryFormActions from './CategoryFormActions';

interface Props {
  defaultValues?: Values;
  graphQLErrors?: readonly GraphQLFormattedError[];
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: Values) => void;
  isEditForm?: boolean;
}

function CategoryForm(props: Props) {
  const {
    defaultValues,
    graphQLErrors,
    loading,
    onCancel,
    onSubmit,
    isEditForm,
  } = props;
  const { t } = useTranslation();
  const fields = getCategoryFormFields({
    t,
  });

  return (
    <Form
      formId="form-category"
      defaultValues={replaceNullsWithUndefined(defaultValues)}
      onSubmit={onSubmit}
      fields={fields}
      actionsComponent={CategoryFormActions}
      actionsComponentProps={{
        isEditForm,
        loading,
        onCancel,
      }}
      graphQLErrors={graphQLErrors}
      loading={loading}
    />
  );
}

export default CategoryForm;
